import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const HistoryModal = ({ title="Update History", open, onClose, history, donorId }) => {
  return (
    <>
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: 900,
          maxHeight: "90vh",
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 3,
          outline: "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="modal-header"
          style={{
            background: "#1976D2",
            color: "white",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <Typography variant="h5" style={{ alignSelf: "center" }}>
            {title} - #{donorId}
          </Typography>
          <IconButton onClick={onClose} data-log="Close Icon Button">
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>
        <div
          className="modal-body"
          style={{ padding: "16px", overflowY: "auto", flexGrow: 1 }}
        >
          {history.length > 0 ? (
            history.map((entry, index) => (
              <Box
                key={index}
                sx={{ mb: 2, p: 2, border: "1px solid #ccc", borderRadius: 2 }}
              >
                <Typography>
                  <strong>Updated By:</strong> {entry.updatedBy || "System"}
                </Typography>
                <Typography>
                  <strong>Time:</strong>{" "}
                  {entry.updatedAt
                    ? new Date(entry.updatedAt).toLocaleString()
                    : "N/A"}
                </Typography>
                {entry.changes?.map((change, idx) => (
                  <Box key={idx} sx={{ pl: 2 }}>
                    <Typography>
                      <strong>Field:</strong> {change.field}
                    </Typography>
                    <Typography>
                      <strong>Old Value:</strong> {change.oldValue || "-"}
                    </Typography>
                    <Typography>
                      <strong>New Value:</strong> {change.newValue || "-"}
                    </Typography>
                  </Box>
                ))}
              </Box>
            ))
          ) : (
            <Typography>No history available</Typography>
          )}
        </div>
      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "16px",
          borderTop: "1px solid #ddd",
        }}
      >
        <Button onClick={onClose} variant="contained" color="error">
          Close
        </Button>
      </div>
      </Box>
    </Modal>
    </>
  );
};

export default HistoryModal;
